var _rect, _rect2, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBottomLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 22,
    viewBox: "0 0 353 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.556641,
    y: 11,
    width: 150,
    height: 1,
    fill: "#D8D6E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 202.234,
    y: 11,
    width: 150,
    height: 1,
    fill: "#D8D6E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.504,
    cy: 11,
    r: 10.5,
    stroke: "#D8D6E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.002 16.696C176.277 16.696 175.621 16.536 175.034 16.216C174.458 15.8854 173.999 15.4 173.658 14.76C173.327 14.12 173.162 13.32 173.162 12.36C173.162 11.4 173.333 10.6 173.674 9.96003C174.026 9.32003 174.49 8.84003 175.066 8.52003C175.653 8.20003 176.298 8.04003 177.002 8.04003C177.834 8.04003 178.57 8.22136 179.21 8.58403C179.85 8.94669 180.357 9.45336 180.73 10.104C181.103 10.744 181.29 11.496 181.29 12.36C181.29 13.224 181.103 13.9814 180.73 14.632C180.357 15.2827 179.85 15.7894 179.21 16.152C178.57 16.5147 177.834 16.696 177.002 16.696ZM172.506 16.6V4.72803H174.042V10.376L173.882 12.344L173.978 14.312V16.6H172.506ZM176.874 15.352C177.418 15.352 177.903 15.2294 178.33 14.984C178.767 14.7387 179.109 14.392 179.354 13.944C179.61 13.4854 179.738 12.9574 179.738 12.36C179.738 11.752 179.61 11.2294 179.354 10.792C179.109 10.344 178.767 9.99736 178.33 9.75203C177.903 9.50669 177.418 9.38403 176.874 9.38403C176.341 9.38403 175.855 9.50669 175.418 9.75203C174.991 9.99736 174.65 10.344 174.394 10.792C174.149 11.2294 174.026 11.752 174.026 12.36C174.026 12.9574 174.149 13.4854 174.394 13.944C174.65 14.392 174.991 14.7387 175.418 14.984C175.855 15.2294 176.341 15.352 176.874 15.352Z",
    fill: "#D8D6E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBottomLine);
export default __webpack_public_path__ + "static/media/home-bottom-line.5a631a4a91579a15a2586420022ceb34.svg";
export { ForwardRef as ReactComponent };